import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { DefaultLabel } from './Label'
import BaseInput from 'react-jsonschema-form/lib/components/widgets/BaseInput'
import dateFnsParse from 'date-fns/parse'

export default class HTMLDateInput extends Component {
  constructor(props) {
    super(props)
    this.format = props.format ? props.format : 'YYYY-MM-DD'
  }

  handleChange(value) {
    if (value) {
      const dt = dateFnsParse(value)
      value = dateFnsFormat(dt, this.format)
    }
    this.props.onChange(value)
  }

  render() {
    const props = this.props
    // console.log('HTMLDateInput props', props)
    return (
      <BaseInput
        type="date"
        min={props.options.min}
        max={props.options.max}
        {...props}
      />
    )
  }
}

HTMLDateInput.propTypes = {
  uiSchema: PropTypes.shape({
    'ui:options': {
      format: PropTypes.string,
      min: PropTypes.string, // must be YYYY-MM-DD format
      max: PropTypes.string, // must be YYYY-MM-DD format
    },
  }),
  onChange: PropTypes.func.isRequired,
}
